module.exports = __webpack_public_path__ + "static/media/japan-flag.6abb52f6.png";